<template>
  <div>
      <SGPModalComponent
        v-if="mostrarModal"
        :mostrarHeader="false"
        :mostrarFooter="false"
        mostrarBody
        tamanho="sm"
        titulo=""
        @sgpModalFechar="cancelar"
        :toolbar="false"
      >
        <div class="sgp-confirmacao">
          <h2> {{ titulo }} </h2>
          <h5 class=""> {{ mensagem }} </h5>

          <div class="container-botoes">
            <SGPFormBotaoComponent type="button" color="light-grey" @click="cancelar()">
              {{ txtCancelar }}
            </SGPFormBotaoComponent>

            <SGPFormBotaoComponent @click="confirmar()" type="submit">
              {{ txtConfirmar }}
            </SGPFormBotaoComponent>
          </div>
        </div>
        
      </SGPModalComponent>
  </div>
</template>

<script>
export default {
  name: 'SGPConfirmacaoComponent',
  
  props: {
    titulo : {
      type: String,
      required: false,
      default: 'Tem certeza disso?',
    },
    mensagem : {
      type: String,
      required: true,
      default: '',
    },
    txtConfirmar: {
      type: String,
      required: true,
      default: 'Confirmar',
    },
    txtCancelar: {
      type: String,
      required: true,
      default: 'Cancelar',
    },
    mostrarModal : {
      type: Boolean,
      required: false,
      default: false
    }
  },

  emit: [
    // evento disparado com o clique do botão de cancelar
    'sgpCancelarEmit',
    // evento disparado com o clique do botão de confirmar
    'sgpConfirmarEmit'
  ],

  methods: {
    cancelar () {
      this.mostrarModal = false;
      setTimeout ( () => {
        this.$emit('sgpCancelarEmit');
      }, 800)
      
    },
    confirmar () {
      this.mostrarModal = false;
      this.$emit('sgpConfirmarEmit');
    },
  }
}
</script>